import { render, staticRenderFns } from "./PolizasRMSMovimientos.vue?vue&type=template&id=32b5e9a0&"
import script from "./PolizasRMSMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports